<template>
    <FieldItem
        :id="id"
        :label="$t(fieldConfig.label)"
    >
        <ElSelect
            v-model="fieldValue"
            class="search-preference__select"
            :placeholder="$t(fieldConfig.label)"
            size="small"
            :disabled="store.settingValues.automatic"
            @change="onChange"
        >
            <ElOption
                v-for="option in store.gapCostsOptions"
                :key="option.value"
                :label="option.label"
                :value="option.value"
            />
        </ElSelect>
    </FieldItem>
</template>

<script>
import Select from 'element-ui/lib/select';
import Option from 'element-ui/lib/option';
import FieldItem from '../components/FieldItem.vue';
import { FieldItemMixin } from './mixins';

export default {
    components: {
        FieldItem,
        ElSelect: Select,
        ElOption: Option,
    },
    mixins: [FieldItemMixin],
    inject: ['store'],
    props: {
        fieldName: {
            type: String,
            default: 'gaps',
        },
    },
    methods: {
        onChange() {
            this.store.afterSetAlgorithmFields();
            this.syncChange();
        },
    },
};
</script>
